import CardRectangleElementConfiguration from './CardRectangleElementConfiguration';

export default CardRectangleElementConfiguration;
